import { render, staticRenderFns } from "./manageCodesList.vue?vue&type=template&id=a8852d60&scoped=true"
import script from "./manageCodesList.vue?vue&type=script&lang=js"
export * from "./manageCodesList.vue?vue&type=script&lang=js"
import style0 from "./manageCodesList.vue?vue&type=style&index=0&id=a8852d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8852d60",
  null
  
)

export default component.exports